import styled from 'styled-components';

export const PreviewBackdrop = styled.div`
  position: absolute;
  inset: 0;
  border-radius: inherit;
  background: linear-gradient(180deg, #18324a 0%, #102437 100%);
  opacity: ${({ $isReady }) => ($isReady ? 0 : 1)};
  transition: opacity 140ms ease;
`;

export const PreviewVideo = styled.video`
  width: calc(100% + 2px);
  height: calc(100% + 2px);
  min-width: calc(100% + 2px);
  min-height: calc(100% + 2px);
  object-fit: cover;
  object-position: center;
  display: block;
  position: absolute;
  inset: -1px;
  background: transparent;
  border: 0;
  transform: scaleX(-1);
  opacity: ${({ $isReady }) => ($isReady ? 1 : 0)};
  transition: opacity 140ms ease;
`;
